export default __webpack_public_path__ + "static/media/login_openapi.c6178e7a.yaml";